
import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getCollections() {
        const url = `${API_URL}/collections`;
        return axios.get(url, { headers: authHeader() });
    },
    getPaginated(params) {
        return axios.get(`${API_URL}/collections/paginated`, {
            headers: authHeader(),
            params,
        });
    },
    createData(data) {
        return axios.post(`${API_URL}/collections`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/collections/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/collections/${id}`, { headers: authHeader() });
    },
};
